import React, {useContext, useEffect, useState} from "react";
import {ReactComponent as LoginIcon} from "../../images/login_blue.svg";
import {
    DEFAULT_LOGIN_METHODS,
    LOGIN_SETTINGS_ERROR_MSG,
    PLATFORM_SETTINGS,
    YUJA_DISABLE_LABEL,
    TEXTBOX,
    PWD_EXPIRY_LABEL,
    USER_SETTINGS,
    DEFAULT_ATTENDANCE_SAVED_LOCATIONS,
    ATTENDANCE_SETTINGS,
    ATTENDANCE_SETTINGS_CARD_SUB_TITLE,
    ATTENDANCE_SETTINGS_GEO_LOCATION_SUB_TITLE,
    PLATFORM_SETTING_SAVED_LOCATIONS_MODAL_DESCRIPTION,
    GEOFENCED_LOCATIONS_TITLE,
    CONFIGURE_TEXT,
    YUJA_LOGIN_OPTION_PLACEHOLDER_TEXT,
    ADFS_LOGIN_OPTION_PLACEHOLDER_TEXT,
    SHIBBOLETH_LOGIN_OPTION_PLACEHOLDER_TEXT,
    GOOGLE_LOGIN_OPTION_PLACEHOLDER_TEXT,
    AZURE_LOGIN_OPTION_PLACEHOLDER_TEXT,
    DCAM_LOGIN_OPTION_PLACEHOLDER_TEXT,
    LMS_API_LINK,
    INTEG_TEXT_BOX,
    EVP_TEXT,
    MODAL_CANCEL_TEXT,
    EVP_INTEGRATION_CARD_TITLE,
    EVP_API_LINK,
    EVP_API_LINK_DESC,
    EVP_API_LINK_PLACEHOLDER,
    EVP_TOKEN,
    EVP_TOKEN_DESC,
    OVERRIDE_TEXT,
    LOGIN_METHODS,
    YUJA_LOGIN_TEXT,
    YUJA_DROPDOWN_SIZE,
    LOGIN_SETTINGS_TEXT,
    PLATFORM_SETTINGS_LOGIN_SETTINGS_CARD_DESCRIPTION,
    YUJA_LOGIN_OPTION_DESCRIPTION,
    ADFS_LOGIN_OPTION_DESCRIPTION,
    SHIBBOLETH_LOGIN_OPTION_DESCRIPTION,
    DCAM_LOGIN_OPTION_DESCRIPTION,
    GOOGLE_LOGIN_OPTION_DESCRIPTION,
    AZURE_LOGIN_OPTION_DESCRIPTION,
    YUJA_LOGIN_OPTION_TITLE,
    ADFS_LOGIN_OPTION_TITLE,
    SHIBBOLETH_LOGIN_OPTION_TITLE,
    DCAM_LOGIN_OPTION_TITLE,
    GOOGLE_LOGIN_OPTION_TITLE,
    AZURE_LOGIN_OPTION_TITLE,
    DEFAULT_LOGIN_OPTION_TITLE,
    DEFAULT_LOGIN_OPTION_DESCRIPTION,
    ENGAGE_LOGIN_CREDENTIALS,
    ENGAGE_LOGIN_CREDENTIALS_DESCRIPTION,
    PWD_EXPIRY_TITLE,
    CONFIGURE_LOCATIONS_TEXT,
    EVP_INTEGRATION_CARD_DESCRIPTION
} from "../../utils/constants";
import {checkAllEmpty, notifyError, notifySuccess} from "../../utils/helpers";
import classes from "./Settings.module.css";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {ReactComponent as AttendanceDetailsIcon} from "../../images/attendance_details.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import SavedLocationsModal from "../../components/modals/SavedLocationsModal";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import useHostResource from "../../hooks/useHostResource";
import {SAVE_SETTINGS_SUCCESS} from "../../utils/toast-message-constants";
import OverrideModal from "../../components/modals/OverrideModal";
import {ReactComponent as API_ICON} from "../../images/apiAccessIcon.svg";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {YuJaGlobalState} from "../../utils/LoadingContext";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";



export default function PlatformSettingTab({
                                               platformSettings,
                                               setPlatformSettings,
                                               loading=false,
                                               setLoading,
}) {
    const {globalHostResource: hostResource} = useContext(YuJaGlobalState);
    const {updatePlatformSetting} = useHostResource(window.location.hostname);
    const {updateSetting} = InstitutionApiCalls();
    const [, setLMSAttemptSetting] = useState("");
    const [showADFS, setShowADFS] = useState(false);
    const [showSHIBBOLETH, setShowSHIBBOLETH] = useState(false);
    const [showDCAM, setShowDCAM] = useState(false);
    const [showGOOGLE, setShowGOOGLE] = useState(false);
    const [showAZURE, setShowAZURE] = useState(false);

    const [showSavedLocationModal, setShowSavedLocationModal] = useState(false);
    const [savedLocations, setSavedLocations] = useState([]);
    const [openOverride, setOpenOverride] = useState(false);

    const standaloneLoginEnabled =  !platformSettings.hasOwnProperty(PLATFORM_SETTINGS.YUJA_LOGIN) || !JSON.parse(platformSettings[PLATFORM_SETTINGS.YUJA_LOGIN]);

    // if (name === LOGIN_METHODS.YUJA) {
    //     return YUJA_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.ADFS) {
    //     return ADFS_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.SHIBBOLETH) {
    //     return SHIBBOLETH_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.DCAM) {
    //     return DCAM_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.GOOGLE) {
    //     return GOOGLE_LOGIN_OPTION_TITLE;
    // } else if (name === LOGIN_METHODS.AZURE) {
    //     return AZURE_LOGIN_OPTION_TITLE;
    // }

    const LOGIN_METHODS_OPTIONS = [
        {label: YUJA_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.YUJA_LOGIN},
        {label: ADFS_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.SSONAME_ADFS},
        {label: SHIBBOLETH_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.SSONAME_SHI},
        {label: DCAM_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.SSONAME_DCAM},
        {label: GOOGLE_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE},
        {label: AZURE_LOGIN_OPTION_TITLE, value: DEFAULT_LOGIN_METHODS.SSONAME_AZURE},

    ];

    useEffect(() => {
        console.log(`platformSettings changed: ${JSON.stringify(platformSettings)}`);
        setSavedLocations(JSON.parse(platformSettings && platformSettings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS)
            ? platformSettings[USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS]
            : DEFAULT_ATTENDANCE_SAVED_LOCATIONS)
        );
    }, [platformSettings]);


    useEffect(() => {
        const {platformSetting, ssoConfig={}} = hostResource;
        if (platformSetting && platformSetting.hasOwnProperty(PLATFORM_SETTINGS.LMS_QUIZ_ATTEMPTS)) {
            const LMSQuizAttempts = platformSetting[PLATFORM_SETTINGS.LMS_QUIZ_ATTEMPTS];
            setLMSAttemptSetting(LMSQuizAttempts);
        }
        if(ssoConfig.ADFS && !checkAllEmpty(ssoConfig.ADFS)) {
          setShowADFS(true);
        }
        if(ssoConfig.SHIBBOLETH && !checkAllEmpty(ssoConfig.SHIBBOLETH)) {
          setShowSHIBBOLETH(true);
        }
        if(ssoConfig.DCAM && !checkAllEmpty(ssoConfig.DCAM)) {
          setShowDCAM(true);
        }
        if(ssoConfig.GOOGLE && !checkAllEmpty(ssoConfig.GOOGLE)) {
          setShowGOOGLE(true);
        }
        if(ssoConfig.AZURE && !checkAllEmpty(ssoConfig.AZURE)) {
          setShowAZURE(true);
        }
    } , [hostResource]) 


    useEffect(() => {
        if (!platformSettings) {
            return; 
        }
        var replaced = false; 
        if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_ADFS && showADFS === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_SHI && showSHIBBOLETH === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_DCAM && showDCAM === false) {
            replaced = true; 
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE && showGOOGLE === false) {
            replaced = true;
        }
        else if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.SSONAME_AZURE && showAZURE == false) {
            replaced = true; 
        }

        if (replaced) {
            const copy = JSON.parse(JSON.stringify(platformSettings));
            copy[PLATFORM_SETTINGS.DEFAULT] = "1";
            setPlatformSettings(copy);
        }
    }, [showADFS, showSHIBBOLETH, showDCAM, showGOOGLE, showAZURE, platformSettings]);

    const handlePwdResetChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.PWD_RESET] = input.checked.toString();
        setPlatformSettings(copy);
    };

    const handleYujaLoginNameChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.YUJA_NAME] = input.value;
        setPlatformSettings(copy);
    }; 

    const handleSSONameChangeADFS = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_ADFS] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONameChangeSHI = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_SHI] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONameChangeDCAM = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_DCAM] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONAMEChangeGOOGLE = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_GOOGLE] = input.value;
        setPlatformSettings(copy);
    }

    const handleSSONAMEChangeAZURE = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.SSONAME_AZURE] = input.value;
        setPlatformSettings(copy);
    }

    const handleDefaultChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.DEFAULT] = input.value;
        setPlatformSettings(copy);
    }

    const changeDefaultLoginMethod = (option) => {
        const copy = JSON.parse(JSON.stringify(platformSettings));
        copy[PLATFORM_SETTINGS.DEFAULT] = option.value;
        setPlatformSettings(copy);
    }

    const savePlatformSettings = (settings) => {
        setLoading(true);
        Promise.all([updateSetting(settings), updatePlatformSetting(settings)])
            .then(() => {
                notifySuccess(SAVE_SETTINGS_SUCCESS);
            }).finally(() => {
                setLoading(false)
            });
    };


    const overwriteModalConfig = {
        title: "Add Access Key",
        okText: "Override",
        cancelText: MODAL_CANCEL_TEXT,
        desc: "Please enter the new access token to override the existing token.",
        okDisabled: true,
        submit: async (val) => {
            const copy = JSON.parse(JSON.stringify(platformSettings));
            copy[PLATFORM_SETTINGS.PRIVATE_EVP_API_TOKEN] = val;
            setPlatformSettings(copy);
            setOpenOverride(false);
        },
        close:  async () => {
            setOpenOverride(false);
        },
    };

    return (
        <>
            <SavedLocationsModal
                show={showSavedLocationModal}
                setShow={setShowSavedLocationModal}
                savedLocations={savedLocations}
                setSavedLocations={setSavedLocations}
                userSettings={platformSettings}
                setUserSettings={setPlatformSettings}
                saveSettingsCallback={savePlatformSettings}
                description={PLATFORM_SETTING_SAVED_LOCATIONS_MODAL_DESCRIPTION}
            />

            <div className={classes.cardBox} style={{minWidth: 500, flex: 1}}>
                <div className={classes.cardBoxHeader}>
                    <LoginIcon  style={{width: 24, height: 24}}/>
                    <span>{LOGIN_SETTINGS_TEXT}</span>
                </div>
                <div className={classes.cardBoxBody}>
                    {!loading &&
                        <>
                            <div className={classes.cardDescription}>
                                {PLATFORM_SETTINGS_LOGIN_SETTINGS_CARD_DESCRIPTION}
                            </div>
                            <div className={classes.loginMethodsGridLayout}>
                                {/*<div tabIndex={0} role={TEXTBOX} className={styles.titleText}>Enterprise Login</div>*/}
                                {/*<div/>*/}

                                <div>
                                    <div className={classes.settingLabel}>{YUJA_LOGIN_OPTION_TITLE}</div>
                                    <div className={classes.settingDescription}>{YUJA_LOGIN_OPTION_DESCRIPTION}</div>
                                </div>
                                <YuJaTextBox
                                    placeholder={YUJA_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                    containerStyle={{fontSize: 14, lineHeight: 1.6,}}
                                    disabled={platformSettings[PLATFORM_SETTINGS.YUJA_LOGIN] === "true"}
                                    type="text"
                                    value={platformSettings[PLATFORM_SETTINGS.YUJA_NAME]}
                                    onChange={handleYujaLoginNameChange}
                                />

                                {showADFS &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{ADFS_LOGIN_OPTION_TITLE}</div>
                                            <div className={classes.settingDescription}>{ADFS_LOGIN_OPTION_DESCRIPTION}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={ADFS_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_ADFS]}
                                            onChange={handleSSONameChangeADFS}
                                        />

                                    </>
                                }


                                {showSHIBBOLETH &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{SHIBBOLETH_LOGIN_OPTION_TITLE}</div>
                                            <div
                                                className={classes.settingDescription}>{SHIBBOLETH_LOGIN_OPTION_DESCRIPTION}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={SHIBBOLETH_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_SHI]}
                                            onChange={handleSSONameChangeSHI}
                                        />
                                    </>
                                }

                                {showDCAM &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{DCAM_LOGIN_OPTION_TITLE}</div>
                                            <div className={classes.settingDescription}>{DCAM_LOGIN_OPTION_DESCRIPTION}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={DCAM_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_DCAM]}
                                            onChange={handleSSONameChangeDCAM}
                                        />
                                    </>
                                }

                                {showGOOGLE &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{GOOGLE_LOGIN_OPTION_TITLE}</div>
                                            <div
                                                className={classes.settingDescription}>{GOOGLE_LOGIN_OPTION_DESCRIPTION}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={GOOGLE_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_GOOGLE]}
                                            onChange={handleSSONAMEChangeGOOGLE}
                                        />
                                    </>
                                }

                                {showAZURE &&
                                    <>
                                        <div>
                                            <div className={classes.settingLabel}>{AZURE_LOGIN_OPTION_TITLE}</div>
                                            <div
                                                className={classes.settingDescription}>{AZURE_LOGIN_OPTION_DESCRIPTION}</div>
                                        </div>
                                        <YuJaTextBox
                                            placeholder={AZURE_LOGIN_OPTION_PLACEHOLDER_TEXT}
                                            containerStyle={{fontSize: "14px", lineHeight: 1.6,}}
                                            type="text"
                                            value={platformSettings[PLATFORM_SETTINGS.SSONAME_AZURE]}
                                            onChange={handleSSONAMEChangeAZURE}
                                        />
                                    </>
                                }
                            </div>
                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{DEFAULT_LOGIN_OPTION_TITLE}</div>
                                    <div className={classes.settingDescription}>{DEFAULT_LOGIN_OPTION_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaDropdown
                                    style={{width: 240}}
                                    data={
                                        LOGIN_METHODS_OPTIONS
                                            .filter(i => !(!standaloneLoginEnabled && i.value === DEFAULT_LOGIN_METHODS.YUJA_LOGIN))
                                            .filter(i => !(!showADFS && i.value === DEFAULT_LOGIN_METHODS.SSONAME_ADFS))
                                            .filter(i => !(!showSHIBBOLETH && i.value === DEFAULT_LOGIN_METHODS.SSONAME_SHI))
                                            .filter(i => !(!showDCAM && i.value === DEFAULT_LOGIN_METHODS.SSONAME_DCAM))
                                            .filter(i => !(!showGOOGLE && i.value === DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE))
                                            .filter(i => !(!showAZURE && i.value === DEFAULT_LOGIN_METHODS.SSONAME_AZURE))
                                    }
                                    onChange={changeDefaultLoginMethod}
                                    size={YUJA_DROPDOWN_SIZE.SMALL}
                                    value={platformSettings[PLATFORM_SETTINGS.DEFAULT]}
                                />
                            </div>


                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{ENGAGE_LOGIN_CREDENTIALS}</div>
                                    <div className={classes.settingDescription}>{ENGAGE_LOGIN_CREDENTIALS_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={ENGAGE_LOGIN_CREDENTIALS}
                                    checked={standaloneLoginEnabled}
                                    onChange={checked => {
                                        if (!showADFS && !showSHIBBOLETH && !showDCAM && !showGOOGLE && !showAZURE) {
                                            notifyError(LOGIN_SETTINGS_ERROR_MSG)
                                            return;
                                        }
                                        const copy = JSON.parse(JSON.stringify(platformSettings));
                                        if (platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.YUJA_LOGIN && !checked) {
                                            if (showADFS) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_ADFS;
                                            } else if (showSHIBBOLETH) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_SHI;
                                            } else if (showDCAM) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_DCAM;
                                            } else if (showGOOGLE) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_GOOGLE;
                                            } else if (showAZURE) {
                                                copy[PLATFORM_SETTINGS.DEFAULT] = DEFAULT_LOGIN_METHODS.SSONAME_AZURE;
                                            }

                                        }
                                        copy[PLATFORM_SETTINGS.YUJA_LOGIN] = (!checked).toString();
                                        setPlatformSettings(copy);
                                    }}
                                />
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{PWD_EXPIRY_TITLE}</div>
                                    <div className={classes.settingDescription}>{PWD_EXPIRY_LABEL}</div>
                                </div>
                                <div style={{flex: 1}}/>

                                <YuJaSwitch
                                    aria-label={PWD_EXPIRY_TITLE}
                                    checked={platformSettings[PLATFORM_SETTINGS.PWD_RESET] === "true"}
                                    onChange={checked => {
                                        const copy = JSON.parse(JSON.stringify(platformSettings));
                                        copy[PLATFORM_SETTINGS.PWD_RESET] = checked.toString();
                                        setPlatformSettings(copy);
                                    }}
                                />
                            </div>



                        </>
                    }

                    {loading &&
                        <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <div style={{flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={21} width={160} inline={true} borderRadius={10}/>
                                    </div>
                                    <div style={{flex: 5}}>
                                    </div>
                                    <div style={{ flex: 3, display: "flex", justifyContent: "center" }}>
                                        <Skeleton height={21} width={50} inline={true} borderRadius={10} />
                                    </div>
                                </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={19} width={90}  inline={true} borderRadius={10} />
                                    </div>
                                    <div style={{ flex: 5 }}>
                                        <Skeleton height={37} inline={true} borderRadius={10} />
                                    </div>
                                    <div style={{ flex: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true} />
                                    </div>
                                </SkeletonTheme>
                                </div>
                                <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                    <Skeleton height={19} width={90}  borderRadius={10} inline={true} />
                                    </div>
                                        <div style={{ flex: 5}}>
                                            <Skeleton height={37} borderRadius={10} inline={true} />
                                        </div>
                                        <div style={{ flex: 3, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                        </div>
                                    </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                        <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                        <Skeleton height={19} width={110} borderRadius={10}  inline={true} />
                                        </div>
                                        <div style={{ flex: 5 }}>
                                            <Skeleton height={37} borderRadius={10} inline={true} />
                                        </div>
                                        <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                            <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                        </div>
                                    </SkeletonTheme>
                                    </div>
                                    <div style={{display: "flex"}}>
                                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                    <div style={{ flex: 3, display: "flex", alignItems: "center" }}>
                                        <Skeleton height={19} width={90} borderRadius={10} inline={true} />
                                    </div>
                                            <div style={{ flex: 5 }}>
                                                <Skeleton height={37} borderRadius={10} inline={true} />
                                            </div>
                                            <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                                <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                            </div>
                                        </SkeletonTheme>
                                        </div>
                                        <div style={{display: "flex"}}>
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                <div style={{ flex: 3, display: "flex", alignItems: "center"}}>
                                    <Skeleton height={19} width={90}  borderRadius={10} inline={true} />
                                    </div>
                                <div style={{ flex: 5 }}>
                                    <Skeleton height={37} borderRadius={10} inline={true} />
                                </div>
                                <div style={{ flex: 3, display: "flex", justifyContent: "center" , alignItems: "center"}}>
                                    <Skeleton height={20} width={20} borderRadius={10} inline={true} circle={true}/>
                                </div>
                            </SkeletonTheme>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <div style={{flex: 1, height: "fit-content", display: "flex", flexDirection: "column", rowGap: 20}}>
                <div className={classes.cardBox} style={{minWidth: 500}}>
                    <div className={classes.cardBoxHeader}>
                        <AttendanceDetailsIcon style={{width: 24, height: 24}}/>
                        <span role={TEXTBOX}>
                            {ATTENDANCE_SETTINGS}
                        </span>
                    </div>
                    <div className={classes.cardBoxBody}>
                        {!loading &&
                            <>
                                <span className={classes.cardDescription}>
                                    {ATTENDANCE_SETTINGS_CARD_SUB_TITLE}
                                </span>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel} style={{whiteSpace: "nowrap"}}>
                                            {GEOFENCED_LOCATIONS_TITLE}
                                        </div>
                                        <div className={classes.settingDescription}>
                                            {ATTENDANCE_SETTINGS_GEO_LOCATION_SUB_TITLE}
                                        </div>
                                    </div>
                                    <div style={{flex: 1}}/>

                                    <YuJaButton style={{whiteSpace: "nowrap"}} onClick={() => setShowSavedLocationModal(true)}>
                                        {CONFIGURE_LOCATIONS_TEXT}
                                    </YuJaButton>
                                </div>
                            </>
                        }
                        {!!loading &&
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            marginTop: 20
                                        }}
                                    >
                                        <div style={{flex: 1}}>
                                            <div>
                                                <Skeleton height={19} width={100} borderRadius={10} inline={true}/>
                                            </div>
                                            <div style={{marginTop: 10}}>
                                                <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                            </div>
                                        </div>

                                        <Skeleton height={30} width={150} borderRadius={10} inline={true}/>
                                    </div>


                                </SkeletonTheme>
                            </div>
                        }

                    </div>
                </div>

                <div className={classes.cardBox} style={{minWidth: 500}}>
                    <div className={classes.cardBoxHeader}>
                        <API_ICON style={{width: 24, height: 24}}/>
                        <span role={TEXTBOX}>
                            {EVP_INTEGRATION_CARD_TITLE}
                        </span>
                    </div>
                    <div className={classes.cardBoxBody}>
                        {!loading &&
                            <>
                                <span className={classes.cardDescription}>
                                    {EVP_INTEGRATION_CARD_DESCRIPTION}
                                </span>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{EVP_API_LINK}</div>
                                        <div className={classes.settingDescription}>{EVP_API_LINK_DESC}</div>
                                    </div>
                                    <YuJaTextBox
                                        label={LMS_API_LINK + INTEG_TEXT_BOX}
                                        placeholder={EVP_API_LINK_PLACEHOLDER}
                                        name="lmsApiLink"
                                        value={platformSettings[PLATFORM_SETTINGS.PRIVATE_EVP_API_LINK]}
                                        containerStyle={{fontSize: 14, lineHeight: 1.6, flex: 1, minWidth: 270}}
                                        onChange={(e) => {
                                            const copy = JSON.parse(JSON.stringify(platformSettings));
                                            copy[PLATFORM_SETTINGS.PRIVATE_EVP_API_LINK] = e.target.value;
                                            setPlatformSettings(copy);
                                        }}
                                    />
                                </div>

                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{EVP_TOKEN}</div>
                                        <div className={classes.settingDescription}>{EVP_TOKEN_DESC}</div>
                                    </div>
                                    <div style={{flex: 1}}/>
                                    <YuJaButton onClick={() => setOpenOverride(true)}>{OVERRIDE_TEXT}</YuJaButton>
                                </div>
                            </>
                        }
                        {!!loading &&
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            marginTop: 20
                                        }}
                                    >
                                        <div style={{flex: 1}}>
                                            <div>
                                                <Skeleton height={19} width={100} borderRadius={10} inline={true}/>
                                            </div>
                                            <div style={{marginTop: 10}}>
                                            <Skeleton height={19} width={"50%"} borderRadius={10} inline={true}/>
                                            </div>
                                        </div>

                                        <Skeleton height={30} width={150} borderRadius={10} inline={true}/>
                                    </div>


                                </SkeletonTheme>
                            </div>
                        }

                    </div>
                </div>
            </div>



            <OverrideModal
                show={openOverride}
                setModalShow={setOpenOverride}
                config={overwriteModalConfig}
                lmsType={EVP_TEXT}
            />


        </>
    );
}